import type { GetCommitmentVsUsageResponsePayload } from '@vy/api-definition';
import { GetCommitmentVsUsageResponseSchema } from '@vy/api-definition';
import type { Period } from '@vy/types';
import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function commitmentVsUsageQuery(period: Partial<Period>) {
  const api = getPrivateApi();
  const report = await api.getCommitmentVsUsage({
    startTime: period.startTime,
    endTime: period.endTime,
  });
  return GetCommitmentVsUsageResponseSchema.parse(report);
}

export function useCommitmentVsUsageReport(
  period: Partial<Period> = {},
  options?: CustomUseQueryOptions<GetCommitmentVsUsageResponsePayload>,
) {
  return useQuery(queryKeys.commitmentVsUsageReport(period), () => commitmentVsUsageQuery(period), {
    suspense: false,
    keepPreviousData: true,
    ...options,
  });
}

export function useRefreshCommitmentVsUsageReport(period: Partial<Period> = {}) {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const data = await commitmentVsUsageQuery(period);
    queryClient.setQueryData(queryKeys.commitmentVsUsageReport(period), data);
  }, [queryClient, period]);
}
